import { render, staticRenderFns } from "./FrkSidebarItem.vue?vue&type=template&id=4aa256cc&scoped=true&"
import script from "./FrkSidebarItem.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FrkSidebarItem.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./FrkSidebarItem.vue?vue&type=style&index=0&id=4aa256cc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa256cc",
  null
  
)

export default component.exports